import { lazy } from 'react'

export const PrimaryGoalV1 = lazy(() => import('./v1/PrimaryGoalV1'))
export const PrimaryGoalV2 = lazy(() => import('./v2/PrimaryGoalV2'))
export const PrimaryGoalV3 = lazy(() => import('./v3/PrimaryGoalV3'))
export const PrimaryGoalV4 = lazy(() => import('./v4/PrimaryGoalV4'))
export const PrimaryGoalV5 = lazy(() => import('./v5/PrimaryGoalV5'))
